<template>
  <FilterBaseQueryString
    ref="filterBaseRef"
    key-storage="backlog-new"
    :show-add-btn="isShowBtnAdd"
    :add-btn-disable="false"
    :list-default-filter="defaultFilters"
    :list-filters="listFilters"
    :sort-fields="sortFields"
    :show-label-header="true"
    @addClick="addHandle"
    @search="searchHandle"
    @change-operator="changeOperator"
  >
    <template #priority="{ item }">
      <b-form-select v-model="item.value" multiple placeholder="chọn">
        <b-form-select-option :value="1">0</b-form-select-option>
        <b-form-select-option :value="2">2</b-form-select-option>
        <b-form-select-option :value="3">3</b-form-select-option>
        <b-form-select-option :value="4">4</b-form-select-option>
        <b-form-select-option :value="5">5</b-form-select-option>
      </b-form-select>
    </template>
  </FilterBaseQueryString>
</template>

<script>
  import FilterBaseQueryString from '@/components/FilterBaseQueryString.vue'
  import { FilterOperators, FilterDataType } from '@/constant/filter'

  const user = JSON.parse(localStorage.getItem('userData'))

  export default {
    components: {
      FilterBaseQueryString,
    },
    props: {
      isShowBtnAdd: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        defaultFilters: [
          {
            name: 'Tất cả',
            conditions: [],
            order: { sortField: 'createdDate', sortType: 'DESC' },
            isSystem: true,
            isDefault: false,
          },
        ],

        listFilters: [
          {
            prefix: '',
            field: { code: 'contractCode', text: 'Mã hợp đồng' },
            opr: FilterOperators.Like,
            allowedOperators: [
              FilterOperators.Like,
              FilterOperators.Equal,
              FilterOperators.NotEqual,
            ],
            value: '',
            valueType: FilterDataType.STRING,
          },
          {
            prefix: '',
            field: { code: 'ownerName', text: 'Tên' },
            opr: FilterOperators.Like,
            allowedOperators: [
              FilterOperators.Like,
              FilterOperators.Equal,
              FilterOperators.NotEqual,
            ],
            value: '',
            valueType: FilterDataType.STRING,
          },
        ],
        sortFields: [
          { value: 'ownerName', label: 'Name' },
          { value: 'createdDate', label: 'Ngày tạo' },
          { value: 'lastModifiedDate', label: 'Ngày cập nhật' },
        ],
      }
    },

    methods: {
      searchHandle(query) {
        this.$emit('search', query)
      },

      addHandle() {
        this.$emit('add')
      },
      changeOperator() {},
    },
  }
</script>

<style scoped></style>
